import { Typography } from 'antd';

const { Text } = Typography;

const features = [
  {
    id: 1,
    isDisabled: false,
    Component: (
      <>
        <Text>Student Access</Text>
        <br />
        <Text>Max. 5 users at a time</Text>
      </>
    ),
  },
  {
    id: 2,
    disabled: false,
    Component: <Text>Access to all videos and songs</Text>,
  },
  {
    id: 3,
    isDisabled: false,
    Component: (
      <Text>
        Access to all games, worksheets, picture dictionaries and flashcards
      </Text>
    ),
  },
  {
    id: 4,
    isDisabled: false,
    Component: <Text>Private lessons via skype</Text>,
  },
];

export default features;
